export const common = {
  loading: "Laden...",
  save: "Speichern",
  saved: "Gespeichert.",
  cancel: "Abbrechen",
  edit: "Bearbeiten",
  delete: "L\u00f6schen",
  add: "Hinzufügen",
  search: "Suchen",
  close: "Schlie\u00dfen",
  submit: "Absenden",
  showMore: "Mehr anzeigen",
  showLess: "Weniger anzeigen",
  back: "Zurück",
  prev: "Zurück",
  next: "Weiter",
  page: "Seite",
  yes: "Ja",
  no: "Nein",
  confirm: "Bestätigen",
  undo: "Rückgängig",
  noResults: "Keine Ergebnisse.",
  results: "Ergebnisse",
  searchPlaceholder: "Website-Titel, Beschreibung, URL oder Kategorie eingeben...",
  genericError: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
  tooManyRequests: "Zu viele Anfragen. Bitte versuchen Sie es später erneut.",
  invalidRequest: "Ungültige Anfrage.",
  sessionExpired: "Sitzung abgelaufen.",
  accessDenied: "Zugriff verweigert.",
  notFound: "Nicht gefunden.",
  serverError: "Server-Fehler.",
  serviceStarting:
    "Der Dienst startet noch. Bitte warten Sie ein paar Sekunden und versuchen Sie es erneut.",
  errorWithStatus: "Fehler ({status}).",
  noConnection: "Keine Verbindung zum Server.",
  unexpectedError: "Ein unerwarteter Fehler ist aufgetreten.",
  validationError: "Bitte überprüfen Sie Ihre Eingaben und versuchen Sie es erneut.",
  externalLinkWarningTitle: "Sie verlassen WebKurator.de",
  externalLinkWarningBody:
    "Wir sind für Inhalte externer Websites nicht verantwortlich und können nicht alle auf unserer Plattform eingegebenen URLs überprüfen. Bitte gehen Sie mit Vorsicht weiter.",
  externalLinkWarningDoNotShowAgain: "Diese Warnung nicht mehr anzeigen.",
  externalLinkWarningProceed: "Trotzdem fortfahren",
};

export const header = {
  title: "WebKurator.de",
  subtitle: "Uni Passau",
  home: "Startseite",
  categories: "Kategorien",
  statistics: "Statistiken",
  search: "Suche",
  messages: "Nachrichten",
  tickets: "Tickets",
  suggest: "Vorschlagen",
  manage: "Verwalten",
  administration: "Administration",
  login: "Anmelden",
  register: "Registrieren",
  logout: "Abmelden",
  myAccount: "Mein Account",
  darkMode: "Dunkelmodus",
  lightMode: "Hellmodus",
  decreaseUiScale: "UI-Größe verkleinern",
  increaseUiScale: "UI-Größe vergrößern",
};

export const footer = {
  about: "Über WebKurator",
  aboutText: "WebKurator.de ist ein Projekt der Universität Passau zur systematischen Sammlung und Kategorisierung deutscher Websites für Archivierungs- und Forschungszwecke.",
  quickLinks: "Schnellzugriff",
  legal: "Rechtliches",
  legalNotice: "Impressum",
  privacy: "Datenschutz",
  terms: "Nutzungsbedingungen",
  help: "Hilfe",
  contact: "Kontakt",
  copyright: "© 2026 Universität Passau. Alle Rechte vorbehalten.",
};
